import { Injectable } from '@angular/core';
import { ComponentBase } from '../../../component-base';
import { MatDialog } from '@angular/material';
import {
  IDialogResult,
  TextEditorComponent
} from '../ng-components/text-editor/text-editor.component';
import { DrawingsHolderService } from '../drawings-holder.service';
import {
  DoublePost,
  SingleCornerPost,
  SelectableIntermediatePost,
  TerminationPost
} from '../object3D';
import { IDoubleClick, IMouseDown } from '../Interfaces';
import { DeleteObjectComponent } from './DeleteObjectComponent';
import { PostEditorComponent } from '../ng-components/post-editor/post-editor.component';
import { PostTextGetterComponent } from '../ng-components/post-text-getter/post-text-getter.component';

declare const THREE: any;

@Injectable()
export class EditPostComponent extends ComponentBase implements IDoubleClick {
  loader = new THREE.ImageLoader();
  selectedObject = [null];
  public scaleCor;

  constructor(
    private dialog: MatDialog,
    private drawings: DrawingsHolderService,
    private deleteComponent: DeleteObjectComponent
  ) {
    super();
    this.disable();
    this.scaleCor = 1;
    this.drawings.onSelect.subscribe(obj => {
      if (obj) {
        if (
          obj[0] instanceof DoublePost ||
          obj[0] instanceof SingleCornerPost ||
          obj[0] instanceof TerminationPost ||
          obj[0] instanceof SelectableIntermediatePost
        ) {
          this.selectedObject = obj;
        } else {
          this.selectedObject = [null];
        }
      } else {
        this.selectedObject = [null];
      }
    });
  }

  dblclick(e: MouseEvent) {
    if (this.selectedObject[0]) {
      let postType;

      if (this.selectedObject[0] instanceof DoublePost) {
        postType = 'C';
      } else if (this.selectedObject[0] instanceof SingleCornerPost) {
        postType = this.selectedObject[0].type;
      } else if (this.selectedObject[0] instanceof TerminationPost) {
        postType = 'TP';
      } else if (this.selectedObject[0] instanceof SelectableIntermediatePost) {
        postType = 'IN';
      }

      let labelPosition = this.selectedObject[0].labelPos
        ? this.selectedObject[0].labelPos
        : 'Center';

      const dialogRef = this.dialog.open(PostEditorComponent, {
        data: {
          postType: postType,
          labelPosition: labelPosition
        },
        width: '250px'
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          // && (result.postType !== postType || result.labelPosition !== labelPosition)) {
          this.selectedObject.forEach(obj => {
            let newPost;
            if (result.postType == 'C' || result.postType == 'TP') {
              const setNewPost = () => {
                newPost.position.copy(obj.position);
                newPost.rotation.y = obj.rotation.y;
                newPost.scaleCor = this.scaleCor;
                newPost.children
                  .filter(ch => (
                    ch.name === 'textPost'
                    || ch.name === "text"
                  ))
                  .forEach(ch => {
                    ch.rotation.y -= newPost.rotation.y;
                    if (ch.setLabelPos) {
                      ch.setLabelPos();
                    }
                  });
                newPost.update();
                this.drawings.canvas.add(newPost);
                this.drawings.canvas.remove(obj);
              };
              if (result.postType == 'C') {
                new THREE.ImageLoader().load('assets/images/scene-plan/c.png', picture => {
                  newPost = new DoublePost(picture);
                  newPost.modifiedAtStep3 = true;
                  setNewPost();
                });
              } else {
                const postText = this.selectedObject[0].text ? this.selectedObject[0].text : null;

                const textDialogRef = this.dialog.open(PostTextGetterComponent, {
                  data: {
                    text: postText
                  },
                  width: '250px'
                });

                textDialogRef.afterClosed().subscribe(res => {
                  if (res.text) {
                    newPost = new TerminationPost(res.text, result.labelPosition);
                    setNewPost();
                  } else {
                    newPost = new TerminationPost();
                    setNewPost();
                  }
                  newPost.modifiedAtStep3 = true;
                });

              }
            } else {
              this.loader.load(
                '../../../../../../assets/images/scene-plan/' +
                result.postType.toLowerCase() +
                '.png',
                picture => {
                  newPost = new SingleCornerPost(result, picture);
                  newPost.modifiedAtStep3 = true;
                  newPost.position.copy(obj.position);
                  newPost.rotation.y = obj.rotation.y;
                  newPost.children
                    .filter(ch => ch.name === 'text')
                    .forEach(ch => {
                      ch.rotation.y -= newPost.rotation.y;
                    });
                  newPost.scaleCor = this.scaleCor;
                  newPost.update();
                  newPost.setLabelPos();
                  this.drawings.canvas.add(newPost);
                  this.drawings.canvas.remove(obj);
                }
              );
            }
          });

          // newPost.position.copy(this.selectedObject.position);
          // newPost.rotation.y = this.selectedObject.rotation.y;
          // newPost.update();
          // this.drawings.canvas.add(newPost);
          // this.drawings.canvas.remove(this.selectedObject);
        }
      });
      return true;
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/proTools/components/EditPostComponent.ts